import { render, staticRenderFns } from "./EmptyIssues.vue?vue&type=template&id=1229f364&scoped=true&"
import script from "./EmptyIssues.vue?vue&type=script&lang=js&"
export * from "./EmptyIssues.vue?vue&type=script&lang=js&"
import style0 from "./EmptyIssues.vue?vue&type=style&index=0&id=1229f364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229f364",
  null
  
)

export default component.exports